import sessionUtil from "../../utils/sessionUtil";
import { AuthState } from "./types";

export const INITINAL_STATE: AuthState = {
  user: null,
  isAuthenticated: sessionUtil.hasSession(),
  isForbidden: false,
};
